import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import ColorButton from '../../../common/ColorButton'
import { StyledFormElement as FormElement } from '../../../common/FormElement'
import { StyledButton as Button } from '../../../common/Button'
import Text from 'common/components/Text'
import ColorBlockOptionsContainer from './ColorBlockOptionsContainer'
import { Menu } from '../../../common/Menu'
import { Icon } from 'common/components/Icon'

export const ColorBlockOptions = ({ color, setColor, upload, t }) => (
  <Fragment>
    <FormElement>
      <Text grey small bold truncate>
        {t('blockOptions.block')}
      </Text>
    </FormElement>

    <ColorButton color={color} onChange={color => setColor(color)}>
      {({ ref, toggle }) => (
        <Button innerRef={ref} onClick={toggle}>
          <FormElement.Swatch color={color} />
          <Text>{t('blockOptions.color')}</Text>
        </Button>
      )}
    </ColorButton>

    <Menu.Divider />

    <Button Component="label" htmlFor="block-upload">
      <Icon icon="plus" />
      <Text>{t('blockOptions.upload')}</Text>
    </Button>
    <input
      type="file"
      id="block-upload"
      accept="image/*"
      style={{ display: 'none' }}
      onChange={e => upload(e)}
    />

    <Menu.Divider />
  </Fragment>
)

ColorBlockOptions.propTypes = {
  block: PropTypes.object.isRequired,
  setColor: PropTypes.func.isRequired,
  boardColor: PropTypes.string
}

export default ColorBlockOptionsContainer(ColorBlockOptions)
